
import Vue from 'vue'
import SuccessIcon from '@/assets/svgs/circled_checkmark_icon.svg?inline'
import WarningIcon from '@/assets/svgs/circled_warning_icon.svg?inline'
import ErrorIcon from '@/assets/svgs/circled_error_icon.svg?inline'
import CloseIcon from '@/assets/svgs/x_close_icon.svg?inline'

export default Vue.extend({
  name: 'Toast',
  created: function () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.onResize)
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    target: {
      type: [Boolean, String],
      required: false,
      default: true,
    },
    offsetY: {
      type: Number,
      required: false,
      default: 32,
    },
    offsetYMobile: {
      type: Number,
      required: false,
      default: 32,
    },
    mobileBreakpoint: {
      type: Number,
      required: false,
      default: 640,
    },
    maxWidth: {
      type: Number,
      required: false,
    },
    // Used by Quasar's tooltip component for screen sizes >= 640
    anchorPosition: {
      type: String,
      required: false,
      default: 'bottom right',
    },
    // Used by Quasar's tooltip component for screen sizes < 640
    anchorPositionMobile: {
      type: String,
      required: false,
      default: 'bottom middle',
    },
    // Used by Quasar's tooltip component for screen sizes >= 640
    selfPosition: {
      type: String,
      required: false,
      default: 'top right',
    },
    // Used by Quasar's tooltip component for screen sizes < 640
    selfPositionMobile: {
      type: String,
      required: false,
      default: 'top middle',
    },
    priority: {
      required: true,
    },
    hasUndoOption: {
      type: Boolean,
      required: false,
      default: false
    },
    closeButtonInCorner: {
      type: Boolean,
      required: false,
      default: false,
    },
    contentClass: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    currentOffsetY: 32,
    currentAnchorPosition: '',
    currentSelfPlacementPosition: '',
    isMobile: false,
    currentMaxWidth: '',
    timeoutId: {} as ReturnType<typeof setTimeout>,
  }),
  beforeMount: function () {
    this.onResize()
  },
  methods: {
    onResize: function () {
      if (window.innerWidth < this.mobileBreakpoint) {
        this.isMobile = true
        this.currentOffsetY = this.offsetYMobile
        this.currentAnchorPosition = this.anchorPositionMobile
        this.currentSelfPlacementPosition = this.selfPositionMobile
        let windowWidthWithSpacing = window.innerWidth - 32
        if (this.maxWidth < windowWidthWithSpacing) {
          this.currentMaxWidth = this.maxWidth + 'px'
        } else if (windowWidthWithSpacing < 500) {
          this.currentMaxWidth = 'calc(100vw - 34px)'
        } else {
          this.currentMaxWidth = '500px'
        }
      } else {
        this.isMobile = false
        this.currentOffsetY = this.offsetY
        this.currentAnchorPosition = this.anchorPosition
        this.currentSelfPlacementPosition = this.selfPosition
        this.currentMaxWidth = this.maxWidth + 'px'
      }
    }
  },
  components: {
    SuccessIcon,
    WarningIcon,
    ErrorIcon,
    CloseIcon
  },
  watch: {
    show: function (value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }
      if (value) {
        this.timeoutId = setTimeout(() => {
          this.$emit('closed', true)
        }, 2400)
      }
    },
    anchorPosition: function () {
      this.onResize()
    },
  },
})
